import React from "react";
import styled from "styled-components";
import { isBrowserContext } from "../../../../util/ContextHelper";

const Img = styled.img`
  opacity: 1;
  transition: opacity linear .5s;

  &.lazy {
    opacity: 0;
  }

  &.lazy-loading {

  }

  &.lazy-loaded {

  }
`;

export interface LazyImageProps
{
    forwardedRef?: React.RefObject<HTMLImageElement>;
}

export interface LayzImageStateProps
{
    isLoaded: boolean;
}

const handleObserve: IntersectionObserverCallback = (entries, observer) =>
{
    entries.forEach(function (entry)
    {
        if (entry.isIntersecting)
        {
            const lazyImage = entry.target as HTMLImageElement;
            if (lazyImage)
            {
                if (lazyImage.dataset.src)
                {
                    lazyImage.classList.add("lazy-loading");
                    lazyImage.src = lazyImage.dataset.src;
                }

                observer.unobserve(lazyImage);
            }
        }
    });
};

const lazyImageObserver = isBrowserContext() ? new IntersectionObserver(handleObserve) : null;

class LazyImage extends React.Component<LazyImageProps & React.ImgHTMLAttributes<{}>, LayzImageStateProps>
{
    _isMounted = false;
    imageRef: React.Ref<HTMLImageElement>;

    state = {
        isLoaded: false
    };

    constructor(props: LazyImageProps)
    {
        super(props);
        this.imageRef = props.forwardedRef || React.createRef<HTMLImageElement>();
        // React.FC<LazyImageProps & React.ImgHTMLAttributes<{}>>
    }

    componentDidMount()
    {
        this._isMounted = true;

        if (lazyImageObserver)
        {
            if (typeof this.imageRef === "function")
            {
                // How to handle functions?
            }
            else if (this.imageRef?.current)
            {
                const lazyImage = this.imageRef.current;
                lazyImage.onload = () =>
                {
                    lazyImage.classList.remove("lazy", "lazy-loading");
                    lazyImage.classList.add("lazy-loaded");

                    if(this._isMounted)
                    {
                        this.setState({
                            isLoaded: true
                        });
                    }
                };

                lazyImageObserver.observe(lazyImage);
            }
        }
    }

    componentWillUnmount()
    {
        this._isMounted = false;

        if (typeof this.imageRef === "function")
        {
            // How to handle functions?
        }
        else if (this.imageRef?.current)
        {
            if (lazyImageObserver)
            {
                lazyImageObserver.unobserve(this.imageRef.current);
            }
        }
    }

    render()
    {
        const { src, className, ...rest } = this.props;
        const lazyClassName = [className, this.state.isLoaded ? "lazy-loaded" : "lazy"].join(" ");

        return <Img ref={this.imageRef}
            src={this.state.isLoaded ? src : undefined}
            data-src={src}
            className={lazyClassName}
            {...rest} />;
    }
}

export default LazyImage;
